import React, { ReactNode } from 'react';

import { useTranslations } from 'next-intl';

import {
  IconDiscord,
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconReddit,
  IconTelegram,
  IconTiktok,
  IconTwitter,
  IconYoutube,
} from '@/blocks/components/Icons/SocialIcons';

import styles from './SocialLink/SocialLink.module.scss';

type SocialLinksData = Record<
  string,
  {
    title: ReactNode;
    content: { icon: ReactNode; className: string; title: ReactNode; link: string }[];
  }
>;

export function useSocialLinksData(): SocialLinksData {
  const tr = useTranslations('pages.community.sections.socialLinks');

  return {
    en: {
      title: tr.rich('global'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram Announcements',
          link: 'https://t.me/primexbt',
        },
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_Global',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/PrimeXBT',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook',
          link: 'https://www.facebook.com/primexbt/',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt_official/',
        },
        {
          icon: <IconDiscord />,
          className: styles.discord,
          title: 'Discord',
          link: 'https://discord.gg/primexbt',
        },
        {
          icon: <IconReddit />,
          className: styles.reddit,
          title: 'Reddit',
          link: 'https://www.reddit.com/r/PrimeXBT/',
        },
        {
          icon: <IconLinkedin />,
          className: styles.linkedin,
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/company/primexbt/',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter Academy',
          link: 'https://x.com/PX_Academy',
        },
        {
          icon: <IconYoutube />,
          className: styles.youtube,
          title: 'Youtube Academy',
          link: 'https://www.youtube.com/PrimeXBTAcademy',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook Academy',
          link: 'https://www.facebook.com/primexbtacademy/',
        },
        {
          icon: <IconTiktok />,
          className: styles.tiktok,
          title: 'TikTok',
          link: 'https://www.tiktok.com/@primexbt_official',
        },
      ],
    },
    es: {
      title: tr.rich('spanish'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_ES',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/PrimexbtES',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook',
          link: 'https://www.facebook.com/primexbtes/',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt.es/',
        },
      ],
    },
    ar: {
      title: tr.rich('arabic'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_Arabic',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/PrimeXBTMENA',
        },
      ],
    },
    // tr: {
    //   title: tr.rich('turkish'),
    //   content: [
    //     // {
    //     //   icon: <IconTelegram />,
    //     //   className: styles.telegram,
    //     //   title: 'Telegram',
    //     //   link: 'https://t.me/PrimeXBT_TR',
    //     // },
    //     // {
    //     //   icon: <IconTwitter />,
    //     //   className: styles.twitter,
    //     //   title: 'Twitter',
    //     //   link: 'https://x.com/PrimeXBTTR',
    //     // },
    //     // {
    //     //   icon: <IconFacebook />,
    //     //   className: styles.facebook,
    //     //   title: 'Facebook',
    //     //   link: 'https://www.facebook.com/primexbttr/',
    //     // },
    //     // {
    //     //   icon: <IconInstagram />,
    //     //   className: styles.instagram,
    //     //   title: 'Instagram',
    //     //   link: 'https://www.instagram.com/primexbt_turkiye/',
    //     // },
    //   ],
    // },
    kr: {
      title: tr.rich('korean'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_KOREA',
        },
      ],
    },
    in: {
      title: tr.rich('indonesian'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_ID',
        },
      ],
    },
    ph: {
      title: tr.rich('filipino'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_Philippines',
        },
      ],
    },

    hi: {
      title: tr.rich('indian'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_IN',
        },
      ],
    },

    vi: {
      title: tr.rich('vietnamese'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_VT',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/primeXBTVI',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook',
          link: 'https://www.facebook.com/PrimeXBTVI/',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt_vn',
        },
      ],
    },
    th: {
      title: tr.rich('thai'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_TH',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/primexbt_th',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook',
          link: 'https://www.facebook.com/primexbtthai/',
        },
      ],
    },
    pt: {
      title: tr.rich('portuguese'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_PT',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/PrimeXBT_PT',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt_pt/',
        },
      ],
    },
    cn: {
      title: tr.rich('chinese'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_China',
        },
      ],
    },
  };
}

export function useSocialLinksAfricaData(): SocialLinksData {
  const tr = useTranslations('pages.community.sections.socialLinks');

  return {
    en: {
      title: tr.rich('global'),
      content: [
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram Announcements',
          link: 'https://t.me/primexbt',
        },
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_Global',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter',
          link: 'https://x.com/PrimeXBT',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook',
          link: 'https://www.facebook.com/primexbt/',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt_official/',
        },
        {
          icon: <IconDiscord />,
          className: styles.discord,
          title: 'Discord',
          link: 'https://discord.gg/primexbt',
        },
        {
          icon: <IconReddit />,
          className: styles.reddit,
          title: 'Reddit',
          link: 'https://www.reddit.com/r/PrimeXBT/',
        },
        {
          icon: <IconLinkedin />,
          className: styles.linkedin,
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/company/primexbt/',
        },
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter Academy',
          link: 'https://x.com/PX_Academy',
        },
        {
          icon: <IconYoutube />,
          className: styles.youtube,
          title: 'Youtube Academy',
          link: 'https://www.youtube.com/PrimeXBTAcademy',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook Academy',
          link: 'https://www.facebook.com/primexbtacademy/',
        },
        {
          icon: <IconTiktok />,
          className: styles.tiktok,
          title: 'TikTok',
          link: 'https://www.tiktok.com/@primexbt_official',
        },
      ],
    },
    za: {
      title: tr.rich('africa'),
      content: [
        {
          icon: <IconTwitter />,
          className: styles.twitter,
          title: 'Twitter Academy',
          link: 'https://x.com/PrimeXBT_ZA',
        },
        {
          icon: <IconInstagram />,
          className: styles.instagram,
          title: 'Instagram',
          link: 'https://www.instagram.com/primexbt_za/',
        },
        {
          icon: <IconFacebook />,
          className: styles.facebook,
          title: 'Facebook Academy',
          link: 'https://www.facebook.com/primexbtza/',
        },
        {
          icon: <IconTelegram />,
          className: styles.telegram,
          title: 'Telegram',
          link: 'https://t.me/PrimeXBT_ZA',
        },
      ],
    },
  };
}
